import React from "react";
import Carousel from "react-material-ui-carousel";
import {
  makeStyles,
  Grid
} from "@material-ui/core";
import { Link } from "react-router-dom";
import Appconfig from "../config/config";
import axios from 'axios';
import moment from "moment";
import Footer from "../includes/Footer";
import Header from "../includes/Header";
import Casino from "../includes/Casino";
import { useQuery, useQueryClient } from 'react-query';
// Import Images
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { postErrorToslack } from "../config/common";
import { getNumberBySiteCode } from '../services/numbers';
import { toast } from 'react-toastify';


const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  dashboardWrap: {
    width: "75%",
    margin: "auto",
    marginTop: "2px",
  },
  AlignCenter: {
    alignItems: "center",
  },
  borderRight: {
    borderRight: "1px solid #999",
    height: "100%",
  },
  marginBottomLast: {
    marginBottom: "24px !important",
  },
}));


function loginAlert() {
  alert("Please Login");
}
function loader_remove() {
  if (document.getElementById("poker_loading")) {
    document.getElementById("poker_loading").style.display = "none";
  }
}


const Dashboard = () => {
  const queryClient = useQueryClient()
  let sportsCount = {
    "cricket": 0,
    "tennis": 0,
    "soccer": 0
  };

  const userInfo = JSON.parse(window.sessionStorage.getItem("userData"));
  const classes = useStyles();
  const [value, setValue] = React.useState(0);
  const [bal, setBal] = React.useState(false);
  const [casinoApiLink, setCasinoApiLink] = React.useState('http://silver.marketsarket.in/casino/');
  const myStoredBal = JSON.parse(window.localStorage.getItem("getBalanceByUser"));
  const isLoggedIn = window.sessionStorage.getItem("loggedIn") && window.sessionStorage.getItem("loggedIn") != "false" ? true : false;
  const [eventListData, setEventListData] = React.useState([]);
  const [bannerList, setBannerList] = React.useState(userInfo ? userInfo.banners : []);
  const [inplaycount, setInplaycount] = React.useState({});
  const [isBannerLoaded, setIsBannerLoaded] = React.useState(false);
  const [whatsappNum, setWhatsAppNumber] = React.useState("");


  const Item = (props) => {
    return <img alt="skyexchange" onLoad={() => setIsBannerLoaded(true)} fetchpriority="low" src={Appconfig.apiUrl + 'banner/' + props.item.image_name} style={{ height: 73, width: "100vw" }} />;
  }

  const getInplayCountNew = () => {
    let config = JSON.stringify({
      user_id: userInfo ? userInfo._id : "",
    });
    return axios.post(`${Appconfig.apiUrl}eventsDashboard/inplayCount`, config, {
      headers: {
        "Content-Type": "application/json",
      }
    });
  }
  const onSuccess = (data) => {
    try {
      if (data) {
        data.data.resultData.map((val, index) => {
          if (val._id == 4) {
            sportsCount.cricket = val.myCount;
          }
          if (val._id == 1) {
            sportsCount.soccer = val.myCount;
          }
          if (val._id == 2) {
            sportsCount.tennis = val.myCount;
          }
        })
      }
      loader_remove();
      setInplaycount(sportsCount);
    } catch (e) {
      postErrorToslack(e.message);
    }
  }
  const onCache = (data) => {
    try {
      if (data) {
        data && data.length && data.map((val, index) => {
          if (val._id == 4) {
            sportsCount.cricket = val.myCount;
          }
          if (val._id == 1) {
            sportsCount.soccer = val.myCount;
          }
          if (val._id == 2) {
            sportsCount.tennis = val.myCount;
          }
        })
      }
      setInplaycount(sportsCount);
    } catch (e) {
      postErrorToslack(e.message);
    }
  }
  const { isLoading, isError, error, data, refetch } = useQuery('inplayCount', getInplayCountNew, {
    onSuccess
  })

  React.useEffect(() => {
    // loader_remove();
    // getInplayCount();
    if (queryClient.getQueryData(`inplayCount`)) {
      onCache(queryClient.getQueryData(`inplayCount`).data.resultData);
    }
    // getDashboardData();
    getBanner();
  }, []);

  async function CreateAndLaunchWCOCasino(provider_code, game_code, type = null) {
    const userData = {
      user_id: userInfo?._id,
      user_name: userInfo?.user_name,
      redirect_url: window.location.hostname,
      provider_code: provider_code,
      game_code: game_code,
      type: type,
    };

    document.getElementById("poker_loading").style.display = "flex";

    try {
      const config = {
        method: "post",
        url: `${Appconfig.apiUrl}wco/login`,
        headers: {
          "Content-Type": "application/json",
        },
        data: JSON.stringify(userData),
      };

      const response = await axios(config);
      let status = response.data.status?.code;
      if (status === "SUCCESS") {
        window.open(response.data.launchURL, "_self");
      }

      if (status == "VALIDATION_ERROR" || status == "UNKNOWN_ERROR") {
        toast.error('Game Not Found.', { autoClose: 2000 });
      } else if (status == "AUTHENTICATION_FAILED") {
        toast.error(response.data.status?.message, { autoClose: 2000 });
      }
    } catch (error) {
      console.log(error);
    } finally {
      document.getElementById("poker_loading").style.display = "none";
    }
  }

  // const awcsport = (placeFormName, gameCode = null) => {
  //   let data = JSON.stringify({
  //     'platform': placeFormName,
  //     'user_name': userInfo.user_name,
  //     'externalURL': "https://skyexchange1.in/",
  //     "gameCode": gameCode
  //   })
  //   var config = {
  //     method: "post",
  //     url: `${Appconfig.apiUrl}awc/awc-login`,
  //     headers: {
  //       "Content-Type": "application/json",
  //     },
  //     data: data
  //   };
  //   axios(config)
  //     .then(function (response) {
  //       try {
  //         if (response.data.result) {
  //           console.log('response',response);
  //           window.location.href = response.data.resultData.url
  //         }
  //       } catch (e) {
  //         postErrorToslack(e.message);
  //       }
  //     }).catch(function (error) {
  //       console.log(error);
  //       postErrorToslack(error.message);
  //     });
  // }
  // const CreateJwtAndLaunchCasino = (casinoGameName) => {
  //   let data = JSON.stringify({
  //     'username': userInfo._id,
  //     'balance': myStoredBal.balance,
  //     'sitename': "https://betbuzz247.bet/",
  //     'is_react': "Yes"
  //   })
  //   var config = {
  //     method: "post",
  //     url: `https://nginx.operator.games:8080/gettoken`,
  //     headers: {
  //       "Content-Type": "application/json",
  //     },
  //     data: data
  //   };
  //   axios(config)
  //     .then(function (response) {
  //       try {
  //         if (response) {
  //           response = JSON.parse(JSON.stringify(response));
  //           if (response) {
  //             var jwtToken = response.data.token;
  //             var link = casinoApiLink + casinoGameName + "/" + jwtToken;

  //             window.location.href = link;
  //           }
  //         }
  //       } catch (e) {
  //         postErrorToslack(e.message);
  //       }
  //     })
  //     .catch(function (error) {
  //       console.log(error);
  //       postErrorToslack(error.message);
  //     });
  // }

  function getBanner() {
    var data = JSON.stringify({
      site_code: Appconfig.sitecodes,
    });
    var config = {
      method: "post",
      url: `${Appconfig.apiUrl}banner/getDashboardBanner`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
    axios(config)
      .then(function (response) {
        try {
          if (response.data.result == 0) {
          } else {
            setBannerList(response.data.resultData);
          }
        } catch (e) {
          postErrorToslack(e.message);
        }
      })
      .catch(function (error) {
        console.log(error);
        postErrorToslack(error.message);
      });
  }
  function getDashboardData() {
    var data = JSON.stringify({
      user_id: userInfo ? userInfo._id : "",
      event_type_id: 0,
    });
    let url = "getDashboardDataTest";
    if (!userInfo) {
      url = "getDashboardDataWithoutUserID";
    }
    var config = {
      method: "post",
      url: `${Appconfig.apiUrl}eventsDashboard/${url}`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
    axios(config)
      .then(function (response) {
        // console.log('eventListData', response.data.resultData);
        try {
          renderEventData(response.data.resultData);
          loader_remove();
        }
        catch (e) {
          loader_remove();
          postErrorToslack(e.message);
        }
      })
      .catch(function (error) {
        console.log(error);
        postErrorToslack(error.message);
      });
  }
  const renderEventData = (eventData) => {
    let tempData = [];
    let inplayArr = [];
    let outPlayArr = [];
    eventData.map((Crick, index) => {
      Crick.competitions.map((competition, index) => {
        competition.events.map((event, index) => {
          if (event.marketTypes.length) {
            if (event.marketTypes[0].marketRunners.length) {
              // console.log('check for market runnner',event.marketTypes[0].marketRunners[0])
              if (event.marketTypes[0].marketRunners[0].selection_id) {
                // console.log('test for empty',event.marketTypes[0].marketRunners.length)
                let sport_type = '';
                // console.log(event);
                if (event.event_type == 4) {
                  sport_type = 'Cricket';
                } else if (event.event_type == 2) {
                  sport_type = 'Tennis';
                }
                else if (event.event_type == 1) {
                  sport_type = 'Soccer';
                }
                // console.log('event.marketTypes[0].marketRunners[0].open_date',event);
                let eventDetail = {
                  sport: sport_type,
                  event_id: event.event_id,
                  name: event.event_name,
                  // time: moment(event.open_date).format("hh:mm"),
                  time: moment(new Date(event.open_date), "MM/DD/YYYY hh:mm:ss A").format("HH:mm"),
                  date: moment(new Date(event.open_date), "MM/DD/YYYY hh:mm:ss A").format("YYYY-MM-DD"),
                  // date: moment(event.open_date).format("YYYY-MM-DD"),
                  is_inplay: event.is_inplay == 'True' ? "Inplay" : "Going Inplay",
                  backFirst: event.marketTypes[0].marketRunners[0].back_1_price,
                  layFirst: event.marketTypes[0].marketRunners[0].lay_1_price,
                  backSecond: event.marketTypes[0].marketRunners[1].back_1_price,
                  laySecond: event.marketTypes[0].marketRunners[1].lay_1_price,
                  selection1Id: event.marketTypes[0].marketRunners[0].selection_id,
                  selection2Id: event.marketTypes[0].marketRunners[1].selection_id,
                  is_fancy: event.is_fancy,
                  is_bookmaker: event.is_bookmaker,
                  market_id: event.marketTypes[0].market_name == "Match Odds" ? event.marketTypes[0].market_id : "",
                  is_pin: event.marketTypes[0].is_pin == "Yes" ? true : false,
                }
                // console.log('eventDetail',eventDetail);
                if (event.is_inplay == 'True') {
                  inplayArr.push(eventDetail)
                } else {
                  outPlayArr.push(eventDetail)
                }
              }
            }
            else {
              // console.log('its empty',event.marketTypes[0].marketRunners.length)
            }
          }
        });
      });
    });
    tempData = inplayArr.concat(outPlayArr);
    setEventListData(tempData);
    window.localStorage.setItem("eventListByUser", JSON.stringify(tempData));
  };


  const getWhatsappNumber = async () => {
    const data = {
      site_code: Appconfig.sitecodes,
    }
    const response = await getNumberBySiteCode(data);
    if (response && response.data && response.data.result) {
      setWhatsAppNumber(response.data?.resultData?.mob_num)
    }
  }

  React.useEffect(() => {
    getWhatsappNumber();
  }, [])

  const settings = {
    dots: false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    speed: 2000,
    autoplaySpeed: 2000,
  };



  return (
    <>
      <Header eventList={eventListData} />
      {isLoggedIn ? null :
        <div id="poker_loading" className="loading-wrap" style={{ display: "flex" }}><div class="loading"><div></div><div></div></div><p>Loading...</p></div>
      }
      {bal && <Casino isOpen={true} />}
      <div className="dashboard">
        <div className={`dashborad-slider ${classes.dashboardWrap}`} style={{ marginTop: userInfo ? 85 : 64, width: "100vw" }}>



          <>
            <Slider {...settings} style={{ height: 87, display: !isBannerLoaded ? 'none' : 'block' }}>
              {bannerList && bannerList.length && bannerList.map((item, i) => (
                <Item key={i} item={item} />
              ))}
            </Slider>

            {
              !isBannerLoaded ?
                <div style={{
                  height: 77, backgroundColor: "#000", marginBottom: 15, justifyContent: "center", display: "flex",
                  justifyContent: "center"
                }}>
                  <img alt="loader" className="loader" src="/images/loading.gif" style={{ height: 70, width: 90 }} />
                </div> : null
            }

          </>




        </div>

        <div className={classes.dashboardWrap}>
          <div className="sport-blocks">
            <Grid container spacing={2}>
              <Grid item md={6} xs={12}>
                <div className="sport-block">
                  <Link to={{
                    pathname: "/in-play",
                    state: eventListData
                  }}>
                    <div className="live-count">
                      <div className="live">
                        <span>
                          <img alt="skyexchange" fetchpriority="low" src="/images/live.svg" />
                        </span>
                        LIVE
                      </div>
                      <div className="sport-count">
                        <span>Cricket</span>
                        <span className="show-number">{inplaycount.cricket}</span>
                      </div>
                      <div className="sport-count">
                        <span>Soccer</span>
                        <span className="show-number">{inplaycount.soccer}</span>
                      </div>
                      <div className="sport-count">
                        <span>Tennis</span>
                        <span className="show-number">{inplaycount.tennis}</span>
                      </div>
                    </div>
                    <img alt="skyexchange" fetchpriority="low" src="/images/banner_sports.webp" />
                    <div className="bottom-title">
                      <div className="title">Sports</div>
                      <div className="play-now">Play Now</div>
                    </div>
                  </Link>
                </div>

              </Grid>

              <Grid item md={6} xs={12}>
                <div className="sport-block" onClick={() => window.open(`https://wa.me/${whatsappNum.replace(/\D/g, '')}`, '_blank')}>
                  <Link to="#">
                    <img alt="skyexchange" fetchpriority="low" src="/images/banner_skyexchangeBlog.png" />
                    {/* <div className="bottom-title">
                      <div className="title">Sports</div>
                      <div className="play-now">Play Now</div>
                    </div> */}
                  </Link>
                </div>
              </Grid>
              <Grid item md={6} xs={12}>
                <div className="sport-block">
                  <div
                    //  to={{
                    //   pathname: "/in-play",
                    //   state: eventListData
                    // }}
                    onClick={() => userInfo ? CreateAndLaunchWCOCasino(`BR`, ``, `EV`) : loginAlert()}
                  >
                    <img alt="skyexchange" fetchpriority="low" src="/images/banner_virtualsports.png" />
                    <div className="bottom-title">
                      <div className="title">Visual Cricket</div>
                      <div className="play-now">Play Now</div>
                    </div>
                  </div>
                </div>

              </Grid>
              {/* <Grid item md={6} xs={12}>
                <div className="sport-block" onClick={() => userInfo ? awcsport('HORSEBOOK') : loginAlert()}>
                  <Link to="#">
                    <img alt="skyexchange" fetchpriority="low" src="/images/horse.64c056fc.webp" />
                    <div className="bottom-title">
                      <div className="title">Sports</div>
                      <div className="play-now">Play Now</div>
                    </div>
                  </Link>
                </div></Grid> */}

              {
                Appconfig.WCOCasino.map((casino, index) => (
                  <Grid key={index} className="prx-4" item md={3} xs={casino.title == 'Royal Gaming' ? 12 : 6}>
                    <div className="sport-block" onClick={() => userInfo ? CreateAndLaunchWCOCasino(casino.provider_code, casino.game_code, casino.type) : loginAlert()}>
                      <Link to="#">
                        <img alt="skyexchange" fetchpriority="low" src={`/wco_images/${casino.src}`} />
                        <div className="bottom-title">
                          <div className="title">{casino.title}</div>
                          <div className="play-now">Play Now</div>
                        </div>
                      </Link>
                    </div>
                  </Grid>
                ))
              }
            </Grid>
          </div>
          <Footer />
        </div>
      </div>
    </>
  );
};
export default React.memo(Dashboard);
